const ts2date = ts => new Date(ts * 1000)
const date2ts = date => Math.ceil(date.valueOf() / 1000)

const addLeadingZero = t => (t < 10 ? '0' : '') + t.toString()

const format = date => {
  if (!date) {
    return '/'
  }
  if (typeof date === 'number') {
    date = ts2date(date)
  }
  const year = addLeadingZero(date.getYear() + 1900)
  const month = addLeadingZero(date.getMonth() + 1)
  const day = addLeadingZero(date.getDate())
  const hour = addLeadingZero(date.getHours())
  const minute = addLeadingZero(date.getMinutes())
  const second = addLeadingZero(date.getSeconds())
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}

export {
  ts2date,
  date2ts,
  format
}



// WEBPACK FOOTER //
// ./examples/helper/ts.js